// extracted by mini-css-extract-plugin
module.exports = {"header":"infoRoute_header__p4Nmw","logo":"infoRoute_logo__3IBiw","description":"infoRoute_description__3ySOP"};